import apiRequest from "../utils/ApiRequest/apiRequest";

const GetAssetsPathApiRequest = async () => {
  const response = await apiRequest(
    "AssetsManagement",
    "GetAssetsPath"
  );

  return response;
};

export { GetAssetsPathApiRequest };
